import React, {useState} from "react";
import{ useDispatch} from "react-redux";
import {logout} from "../features/authSlice";
import {useNavigate} from "react-router-dom";
import {NavLink} from "react-router-dom";
import {assets} from "../assets/assets";
import {useLogoutMutation} from "../../src/features/userApiSlice";
import {Menu} from "lucide-react";


export default function HamburgerMenu({projectId}: {projectId: any}) {

    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const dispatch = useDispatch();

    const [logoutApiCall] = useLogoutMutation();

    const logoutHandler = async () => {
        try {
            // @ts-ignore
            await logoutApiCall().unwrap()
            // @ts-ignore
            dispatch(logout())

            setIsMenuOpen(false);

            navigate("/");

        } catch (error) {
            console.log(error);
        }
    }


    return (

        <main>
            <header className="w-full flex items-center justify-between px-2 py-2 bg-white border-b border-slate-200">

                {/* Logo */}
                <NavLink to="/" className="inline-block">
                    <img
                        src={assets.k_Solution_logo}
                        alt="K Solution"
                        className="w-[120px] rounded-md shadow-md"
                    />
                </NavLink>

                {/* Menu */}
                <div className="relative">
                    <button
                        type="button"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="
                flex items-center justify-center
                w-11 h-11
                rounded-lg
                border border-slate-200
                bg-white
                text-slate-700
                hover:bg-yellow-100
                transition
            "
                    >
                        <Menu size={24} />
                    </button>

                    {/* Dropdown */}
                    {isMenuOpen && (
                        <div className="
                absolute
                right-0
                mt-2
                w-52
                bg-white
                border border-slate-200
                rounded-xl
                shadow-xl
                overflow-hidden
                z-50
            ">

                            <NavLink
                                to="/"
                                onClick={() => setIsMenuOpen(false)}
                                className="
                        block px-4 py-3
                        text-sm font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                                Home
                            </NavLink>

                            <NavLink
                                to={`/management/employeeList/${projectId}`}
                                onClick={() => setIsMenuOpen(false)}
                                className="
                        block px-4 py-3
                        text-sm font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                                Team Daily Attendance
                            </NavLink>

                            <NavLink
                                to={`/management/employeeList/${projectId}`}
                                onClick={() => setIsMenuOpen(false)}
                                className="
                        block px-4 py-3
                        text-sm font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                                Team Daily Attendance
                            </NavLink>

                            <NavLink
                                to={`/management/weeklytimesheet/${projectId}`}
                                onClick={() => setIsMenuOpen(false)}
                                className="
                        block px-4 py-3
                        text-sm font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                                Team WK TimeSheet
                            </NavLink>

                            <NavLink
                                to={`/management/users/${projectId}`}
                                onClick={() => setIsMenuOpen(false)}
                                className="
                        block px-4 py-3
                        text-sm font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                               Users Configuration
                            </NavLink>

                            <button

                                onClick={() => logoutHandler()}
                                className="
                        block px-4 py-3
                        text-sm w-full justify-items-start font-medium text-slate-700
                        hover:bg-slate-100
                        transition
                    "
                            >
                                Logout
                            </button>

                        </div>
                    )}
                </div>
            </header>
        </main>
    )
}